import React from 'react';
import { Glyphicon, GlyphiconProps } from 'react-bootstrap'

export interface IconProps extends GlyphiconProps {};

export const Icon: React.FC<IconProps> = (props) => {
    if (props.glyph) {
        return <Glyphicon {...props}  />;
    }
    //todo: props.fa for fontawesome? props.whatever for another font library??
    
    return null;
}

(Icon as any).displayName = "Icon";